import { jsx as _jsx } from "react/jsx-runtime";
import s from './SegmentedControl.module.css';
export function SegmentedControl({ value, onChange, options, }) {
    return (_jsx("div", { className: s.root, role: "tablist", children: options.map((o) => (_jsx("button", { type: "button", role: "tab", "aria-selected": o.value === value, "data-active": o.value === value ? 'true' : 'false', onClick: () => onChange(o.value), className: s.opt, children: o.label }, o.value))) }));
}
